// extracted by mini-css-extract-plugin
export default {"Icon":"qQIEJoLs","IconContainer":"U0y2jd1E","Badge":"ttPy9KNx","Shelf":"FXfHsMQs","Content":"aR9Ozmbw","CloseButton":"OHmAvRgI"};